export enum ApplicationType {
  ZBusiness = "ZBusiness",
  Aviation = "Aviation",
}
